import React from "react";

import styled from "@mui/material/styles/styled";
import Typography from "@mui/material/Typography";

import Stack, { Row, StackProps } from "@rui/Stack";

export const StepCard = styled(Stack)(({ theme }) => ({
  width: "100%",
  height: "100%",
  flexGrow: 1,
  alignItems: "center",
  justifyContent: "flex-start",
  [theme.breakpoints.up("md")]: {
    minHeight: "100vh",
    justifyContent: "space-between",
  },
}));

export const StepCardContent = styled(Stack)(({ theme }) => ({
  width: "100%",
  maxWidth: "700px",
  padding: "20px",
  flexGrow: 1,
  alignItems: "center",
  justifyContent: "flex-start",
  [theme.breakpoints.up("md")]: {
    justifyContent: "center",
  },
}));

export const StepHeader = styled<React.FC<StackProps>>((props) => (
  <Stack spacing={1} {...props} />
))(({ theme }) => ({
  alignItems: "center",
  width: "100%",
  [theme.breakpoints.down("md")]: {
    paddingTop: theme.spacing(3),
  },
}));

export const StepTitle = styled(Typography)(({ theme }) => ({
  ...theme.typography.h1,
  color: theme.palette.shades.neutral[800],
  textAlign: "center",
}));

export const StepDescription = styled(Typography)(({ theme }) => ({
  ...theme.typography.bodyPrimaryReg,
  color: theme.palette.shades.neutral[600],
  fontSize: "0.875rem",
  lineHeight: "16px",
  textAlign: "center",
}));

export const StepFooter = styled<React.FC<StackProps>>((props) => (
  <Row variant="center" spacing={2} {...props} />
))(({ theme }) => ({
  minHeight: "92px",
  flexShrink: 0,
  width: "100%",
  padding: theme.spacing(0, 1),
  borderTop: `1px solid ${theme.palette.shades.neutral[100]}`,
}));
